import React from 'react';
import './App.css';
import SiteHeader from './components/siteHeader/siteHeader';
import HomePage from './containers/homePage/homePage';
import LoginPage from './containers/loginPage/loginPage';
import CampaignsPage from './containers/campaignPage/campaignPage';
import RulePage from './containers/offerPage/rulePage';
import RuleDetailsPage from './containers/offerPage/ruleDetailsPage';
import ImportCafFilePage from './containers/importCafFilePage/importCafFilePage';
import AddNewCampaignPage from './containers/campaignPage/addNewCampaignPage';
import PromotionListPage from './containers/promotionPage/promotionListPage';
import PromotionEditPage from './containers/promotionPage/promotionEditPage';
import OfferListPage from './containers/offerPage/offerListPage';
import OfferEditPage from './containers/offerPage/offerEditPage';
import StoreRegionPage from './containers/storeRegion/storeRegionPage';
import BatchProcessPage from './containers/batchProcessPage/batchProcessPage';
import WwConversionRatePage from './containers/wwConversionRate/wwConversionRatePage';
import DealFunderListPage from './containers/dealFunderPage/dealFunderListPage';
import DealFunderEditPage from './containers/dealFunderPage/dealFunderEditPage';
import SupplierRebatePage from './containers/supplierRebatePage/supplierRebatePage';
import LossPreventionSettingsPage from './containers/lossPrevention/lossPreventionSettingsPage';
import SupplierRebateSearch from './containers/supplierRebatePage/supplierRebateSearch';
import PurchaseRebatePage from './containers/purchaseRebate/purchaseRebatePage';
import PurchaseRebateDetails from './containers/purchaseRebate/purchaseRebateDetails';

import { BrowserRouter, Route, Link, Routes } from 'react-router-dom';
import { Container } from 'reactstrap';
import { ToastContainer } from 'react-toastify';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';

const AccountPage = () => <div>This is an Account Page</div>;

const BaseLayout = () => (
  <div className='base' id='outer-container'>
    <div className='global-nav'>
      <Link to='/'>
        <SiteHeader />
      </Link>
      <br />
      <h5 className='navHeadings'>Scan Rebates</h5>
      <Link to='/campaign'>Campaign</Link>
      <br />
      <Link to='/promotions'>Promotions</Link>
      <br />
      <Link to='/offers'>Offers</Link>
      <br />
      <br />
      <h5 className='navHeadings'>Purchase Rebates</h5>
      <Link to='/supplier-rebate'>Purchase Rebate Suppliers</Link>
      <br />
      <Link to='/purchase-rebate'>Purchase Rebate</Link>
      <br />
      <br />
      <h5 className='navHeadings'>Configuration</h5>
      <Link to='/conversion-rate'>Conversion Rate</Link>
      <br />
      <Link to='/storeRegion'>Site Region Mapping</Link>
      <br />
      <Link to='/dealFunder'>Deal Funders</Link>
      <br />
      <Link to='/batch-process'>Batch Process</Link>
      <br />
      <Link to='/loss-prevention-settings'>Loss Prevention Settings</Link>
    </div>

    <main id='page-wrap'>
      <br />
      <Container fluid>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/login' element={<LoginPage />} />
          <Route path='/offers/add-offer' element={<OfferEditPage />} />
          <Route path='/offers/:offerId' element={<RulePage />} />
          <Route path='/offers' element={<OfferListPage />} />
          <Route
            path='/campaign/:campaignId/promotions/:promotionId/offers/add-offer'
            element={<OfferEditPage />}
          />
          <Route
            path='/campaign/:campaignId/promotions/:promotionId/offers/:offerId/rules/:ruleId'
            element={<RuleDetailsPage />}
          />
          <Route
            path='/campaign/:campaignId/promotions/:promotionId/offers/:offerId/rules'
            element={<RulePage />}
          />
          <Route
            path='/campaign/:campaignId/promotions/:promotionId/offers/:offerId'
            element={<OfferEditPage />}
          />
          <Route
            path='/campaign/:campaignId/promotions/:promotionId/offers'
            element={<OfferListPage />}
          />
          <Route
            path='/campaign/add-campaign'
            element={<AddNewCampaignPage />}
          />
          <Route
            path='/campaign/:campaignId/add-promotion'
            element={<PromotionEditPage />}
          />
          <Route
            path='/campaign/:campaignId/promotions/:promotionId'
            element={<PromotionEditPage />}
          />
          <Route
            path='/campaign/:campaignId'
            element={<AddNewCampaignPage />}
          />
          <Route path='/campaign' element={<CampaignsPage />} />
          <Route
            path='/promotions/add-promotion'
            element={<PromotionEditPage />}
          />
          <Route
            path='/promotions/:promotionId'
            element={<PromotionEditPage />}
          />
          <Route path='/promotions' element={<PromotionListPage />} />
          <Route path='/Account' element={<AccountPage />} />
          <Route
            path='/offer/:offerId/caffile'
            element={<ImportCafFilePage />}
          />
          <Route path='/offer/:offerId' element={<RulePage />} />
          <Route path='/storeRegion' element={<StoreRegionPage />} />
          <Route path='/batch-process' element={<BatchProcessPage />} />
          <Route path='/conversion-rate' element={<WwConversionRatePage />} />
          <Route
            path='/loss-prevention-settings'
            element={<LossPreventionSettingsPage />}
          />
          <Route path='/purchase-rebate' element={<PurchaseRebatePage />} />
          <Route path='/purchase-rebate-form' element={<ImportCafFilePage />} />
          <Route
            path='/purchase-rebate-details/:funderId'
            element={<PurchaseRebateDetails />}
          />
          <Route path='/supplier-rebate' element={<SupplierRebatePage />} />
          <Route
            path='/supplier-rebate-search'
            element={<SupplierRebateSearch />}
          />
          <Route path='/dealFunder/new' element={<DealFunderEditPage />} />
          <Route
            path='/dealFunder/:dealFunderId'
            element={<DealFunderEditPage />}
          />
          <Route path='/dealFunder' element={<DealFunderListPage />} />
          {/* <Route path="/offer" element={<OfferBasePage />} /> */}
        </Routes>
      </Container>
    </main>
    {/* <SiteFooter /> */}
    <div></div>
    <ToastContainer autoClose={5000} position='top-right' />
  </div>
);

const App = () => {
  return (
    <BrowserRouter>
      <BaseLayout />
    </BrowserRouter>
  );
};

export default App;
